<span
  *ngIf="variant === 'icon'"
  class="text-wrapper"
  nz-typography
  nzCopyable
  [nzCopyText]="textToCopy"
  [nzCopyTooltips]="[
    customCopyTooltipText ? customCopyTooltipText : ('BUTTON.COPY' | translate),
    'BUTTON.COPIED' | translate
  ]"
  [nzCopyIcons]="[copyIconTpl, copiedIconTpl]"
  [ngClass]="size"
></span>

<span
  *ngIf="variant === 'button'"
  class="text-wrapper"
  nz-typography
  nzCopyable
  [nzCopyText]="textToCopy"
  [nzCopyTooltips]="null"
  [nzCopyIcons]="[copyButtonTpl, copiedButtonTpl]"
  [ngClass]="size"
></span>

<ng-template #copyIconTpl>
  <span
    nz-typography
    [ngClass]="
      customClass ? customClass + ' text-display-left' : 'text-display-left'
    "
    [nzType]="nzColor"
    *ngIf="textPosition === 'left'"
  >
    {{ textToDisplay }}
  </span>
  <ng-container *ngIf="nzTheme === 'outline'">
    <span
      class="outlined-copy"
      (mouseenter)="hovered = true"
      (mouseleave)="hovered = false"
      (click)="hovered = false"
    >
      <span
        nz-icon
        nzType="copy"
        [nzTheme]="hovered ? 'fill' : 'outline'"
      ></span>
    </span>
  </ng-container>
  <ng-container *ngIf="nzTheme === 'fill'">
    <span
      class="outlined-copy"
      (mouseenter)="hovered = true"
      (mouseleave)="hovered = false"
      (click)="hovered = false"
    >
      <span
        nz-icon
        nzType="copy"
        [nzTheme]="hovered ? 'outline' : 'fill'"
      ></span>
    </span>
  </ng-container>
  <span
    nz-typography
    [ngClass]="
      customClass ? customClass + ' text-display-right' : 'text-display-right'
    "
    [nzType]="nzColor"
    *ngIf="textPosition === 'right'"
  >
    {{ textToDisplay }}
  </span>
</ng-template>

<ng-template #copiedIconTpl>
  <span
    nz-typography
    [ngClass]="
      customClass ? customClass + ' text-display-left' : 'text-display-left'
    "
    [nzType]="nzColor"
    *ngIf="textPosition === 'left'"
  >
    {{ textToDisplay }}
  </span>
  <span class="checked-copy">
    <span nz-icon nzType="check" nzTheme="outline"></span>
  </span>
  <span
    nz-typography
    [ngClass]="
      customClass ? customClass + ' text-display-right' : 'text-display-right'
    "
    [nzType]="nzColor"
    *ngIf="textPosition === 'right'"
  >
    {{ textToDisplay }}
  </span>
</ng-template>

<ng-template #copiedButtonTpl>
  <span>
    <span class="copy-button-text">
      {{ "BUTTON.COPIED" | translate }}
    </span>
    <i class="fal fa-check"></i>
  </span>
</ng-template>

<ng-template #copyButtonTpl>
  <span class="copy-button">
    <span class="copy-button-text">
      {{ textToDisplay }}
    </span>
    <i class="fal fa-copy"></i>
  </span>
</ng-template>
